import React, { useState } from 'react';
import { FiSend, FiShield, FiClock } from 'react-icons/fi';
import SafeIcon from '../components/SafeIcon';
import PageHeader from '../components/shared/PageHeader';

const Quote = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitted(true);
    }, 800);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <PageHeader 
        title="Request a Free Estimate" 
        subtitle="Fill out the form below and one of our comfort specialists will get back to you shortly."
      />

      <section className="section-padding bg-bg">
        <div className="container-custom">
          <div className="flex flex-col lg:flex-row gap-12 max-w-6xl mx-auto">
            
            {/* Form Side */}
            <div className="lg:w-2/3 bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-gray-100">
              {isSubmitted ? (
                <div className="text-center py-16">
                  <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <SafeIcon icon={FiSend} className="text-4xl" />
                  </div>
                  <h3 className="text-3xl font-bold mb-4">Request Received!</h3>
                  <p className="text-lg text-muted mb-8">Thank you for contacting NorthPeak. A team member will reach out to you within 24 hours to discuss your project.</p>
                  <button onClick={() => setIsSubmitted(false)} className="btn-secondary">Submit Another Request</button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="firstName" className="block text-sm font-semibold text-gray-700 mb-1">First Name *</label>
                      <input type="text" id="firstName" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all" placeholder="John" />
                    </div>
                    <div>
                      <label htmlFor="lastName" className="block text-sm font-semibold text-gray-700 mb-1">Last Name *</label>
                      <input type="text" id="lastName" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all" placeholder="Doe" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-1">Email Address *</label>
                      <input type="email" id="email" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all" placeholder="john@example.com" />
                    </div>
                    <div>
                      <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-1">Phone Number *</label>
                      <input type="tel" id="phone" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all" placeholder="(514) 555-0123" />
                    </div>
                  </div>

                  <div>
                     <label htmlFor="address" className="block text-sm font-semibold text-gray-700 mb-1">Street Address</label>
                     <input type="text" id="address" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all" placeholder="123 Main St, Appt 4B" />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="serviceType" className="block text-sm font-semibold text-gray-700 mb-1">Service Type *</label>
                      <select id="serviceType" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all bg-white">
                        <option value="">Select a service...</option>
                        <option value="new_install">New System Installation</option>
                        <option value="repair">System Repair</option>
                        <option value="maintenance">Maintenance</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div>
                      <label htmlFor="time" className="block text-sm font-semibold text-gray-700 mb-1">Preferred Contact Time</label>
                      <select id="time" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all bg-white">
                        <option value="morning">Morning (8AM - 12PM)</option>
                        <option value="afternoon">Afternoon (12PM - 5PM)</option>
                        <option value="evening">Evening (5PM - 8PM)</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="description" className="block text-sm font-semibold text-gray-700 mb-1">How can we help? (Optional)</label>
                    <textarea id="description" rows="4" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all resize-none" placeholder="Please describe the issue or what you are looking for..."></textarea>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Upload Photos (Optional)</label>
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition-colors cursor-pointer">
                      <span className="text-sm text-gray-500">Click to upload photos of your current equipment or the space.</span>
                      <input type="file" className="hidden" multiple accept="image/*" />
                    </div>
                  </div>

                  <button type="submit" className="btn-primary w-full text-lg py-4">
                    This is a demo form
                  </button>
                  <p className="text-xs text-center text-gray-500 mt-4">By submitting this form, you agree to be contacted by NorthPeak Heating & Cooling.</p>
                </form>
              )}
            </div>

            {/* Info Side */}
            <div className="lg:w-1/3 flex flex-col gap-6">
              <div className="bg-primary text-white p-8 rounded-2xl shadow-lg">
                <h3 className="text-xl font-bold mb-4">Need Immediate Help?</h3>
                <p className="text-blue-100 mb-6 text-sm">If your system is completely down or you smell gas, please do not use this form. Call us immediately for emergency service.</p>
                <a href="tel:5145550122" className="btn-secondary border-white text-white hover:bg-white hover:text-primary w-full justify-center">
                  Call (514) 555-0122
                </a>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                <div className="flex items-start gap-4 mb-4">
                  <div className="bg-blue-50 p-3 rounded-lg text-primary">
                    <SafeIcon icon={FiShield} className="text-xl" />
                  </div>
                  <div>
                    <h4 className="font-bold">No Obligation Quotes</h4>
                    <p className="text-sm text-muted mt-1">Our estimates for new installations are completely free and come with no pressure to buy.</p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                <div className="flex items-start gap-4 mb-4">
                  <div className="bg-orange-50 p-3 rounded-lg text-accent">
                    <SafeIcon icon={FiClock} className="text-xl" />
                  </div>
                  <div>
                    <h4 className="font-bold">Fast Turnaround</h4>
                    <p className="text-sm text-muted mt-1">We aim to review all online requests within business hours and schedule visits promptly.</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Quote;